import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormControl, UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';

import { SoftwareInfoPluginService } from './softwareinfo-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';
import { ApplicationType } from '../../utils';

@Component({
    selector: 'softwareinfo-edit',
    templateUrl: './softwareinfo-edit.component.html',
    standalone: false
})
export class SoftwareInfoEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  editForm: UntypedFormGroup;
  public currentItem: any;
  public softwareInfos: any;
  public processing = false;
  public machines: any[];
  public applicationType = 0;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: SoftwareInfoPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service
      .updateSoftwareInfo(this.inspectionId, this.pointId, this.pluginId, model.softwareInfos)
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.applicationType = data.inspection.applicationType;
      this.softwareInfos = this.plugin.config.SoftWareInfos != null ? this.plugin.config.SoftWareInfos : [];
      if (this.applicationType === ApplicationType.Optimization) {
        let machines =
          data.inspection.data != null && data.inspection.data.machine != null ? data.inspection.data.machine : null;
        if (machines) {
          if (!(machines instanceof Array)) {
            machines = [this.machines];
          }
          this.machines = machines ? machines.map((m) => m.name) : [];
        }
      }
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['softwareInfos'];
    control.removeAt(i);
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['softwareInfos'];
    control.push(this.initSoftwareInfo());
  }

  initSoftwareInfo(el?: any) {
    return this.fb.group({
      Name: [el ? el.Name : ''],
      Version: [el ? el.Version : ''],
      Equipment: [el ? el.Equipment : '', this.applicationType === 1 ? [Validators.required] : []]
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      softwareInfos: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['softwareInfos'];
    _.forEach(this.softwareInfos, (el) => {
      control.push(this.initSoftwareInfo(el));
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['softwareInfos'];
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
